import type { ShareFile } from './image';

/**
 * Entrega dos arquivos gerados: a folha de compartilhamento do sistema (no celular, é
 * por ela que a imagem e o PDF chegam ao WhatsApp como arquivo), o download e a cópia
 * da imagem para colar no WhatsApp Web.
 */

const toFiles = (files: readonly ShareFile[]) =>
  files.map(({ name, blob }) => new File([blob], name, { type: blob.type }));

/** O navegador compartilha arquivos deste tipo? (Celular e alguns navegadores de computador.) */
export function canShareFiles(
  sample: { type: string; name: string } = { type: 'image/png', name: 'escala.png' }
): boolean {
  try {
    return (
      typeof navigator !== 'undefined' &&
      typeof navigator.canShare === 'function' &&
      navigator.canShare({ files: [new File([], sample.name, { type: sample.type })] })
    );
  } catch {
    return false;
  }
}

/** Abre a folha de compartilhamento. `false` quando a pessoa desistiu. */
export async function shareFiles(files: readonly ShareFile[], title: string): Promise<boolean> {
  try {
    await navigator.share({ files: toFiles(files), title });

    return true;
  } catch (error) {
    if (error instanceof DOMException && error.name === 'AbortError') return false;

    throw error;
  }
}

export function downloadFile({ name, blob }: ShareFile): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');

  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/** Baixa um a um: o navegador costuma barrar vários downloads disparados juntos. */
export async function downloadFiles(files: readonly ShareFile[]): Promise<void> {
  for (const [i, file] of files.entries()) {
    if (i) await new Promise((resolve) => setTimeout(resolve, 300));

    downloadFile(file);
  }
}

export function canCopyImage(): boolean {
  return typeof ClipboardItem !== 'undefined' && typeof navigator.clipboard?.write === 'function';
}

export async function copyImage(file: ShareFile): Promise<void> {
  await navigator.clipboard.write([new ClipboardItem({ [file.blob.type]: file.blob })]);
}
